import React from 'react';
import { Platform, Pressable, ScrollView, StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { useTheme } from '@/context/ThemeContext';
import { isDarkTheme } from '@/constants/Colors';

// Keep the menu outside the clipped input bubble for native hit testing.
export default function ComposerCommandSuggestions({ goalPrompt, schedulePrompt, onSelect, onSelectSchedule, onDismiss }) {
  const { theme } = useTheme();
  const dark = isDarkTheme(theme);
  const palette = dark
    ? { surface: '#1C1C1C', hover: '#282828', border: '#383838', text: '#FFFFFF', secondary: '#B3B3B3' }
    : { surface: '#FFFFFF', hover: '#F5F5F5', border: '#E5E5E5', text: '#040404', secondary: '#616161' };
  const commands = [
    ...(goalPrompt ? [{ id: 'goal', label: 'Set a long-running goal', description: 'Set an objective for Work to keep pursuing.', icon: 'bullseye', onPress: onSelect }] : []),
    ...(schedulePrompt ? [{ id: 'schedule', label: 'Schedule a task', description: 'Choose when Gab AI should run a task.', icon: 'clock', onPress: onSelectSchedule }] : []),
  ];
  if (!commands.length) return null;
  return <View testID="composer-command-popup" style={[styles.container, { backgroundColor: palette.surface, borderColor: palette.border }]}>
    <View style={styles.row}>
      <ScrollView style={{ flex: 1 }} keyboardShouldPersistTaps="always" scrollEnabled={false}>
        {commands.map(command => <Pressable key={command.id} accessibilityRole="button" accessibilityLabel={command.label}
          onPress={command.onPress} {...(Platform.OS === 'web' ? { onMouseDown: event => event.preventDefault() } : {})}
          style={({ hovered, pressed }) => [styles.command, (hovered || pressed) && { backgroundColor: palette.hover }]}>
          <View style={[styles.symbol, { backgroundColor: palette.hover }]}><Icon name={command.icon} size={16} color={palette.text} /></View>
          <View style={styles.copy}>
            <Text size="s" weight="medium" style={{ color: palette.text }}>{`/${command.id} · ${command.label}`}</Text>
            <Text size="xs" style={{ color: palette.secondary }}>{command.description}</Text>
          </View>
        </Pressable>)}
      </ScrollView>
      <Pressable accessibilityRole="button" accessibilityLabel="Dismiss command suggestions" onPress={onDismiss} style={styles.dismiss}>
        <Text size="n" style={{ color: palette.secondary }}>×</Text>
      </Pressable>
    </View>
  </View>;
}

const styles = StyleSheet.create({
  container: { marginHorizontal: 8, marginBottom: 6, borderRadius: 12, borderWidth: 1, overflow: 'hidden', flexShrink: 0 },
  row: { flexDirection: 'row', alignItems: 'stretch' },
  command: { flexDirection: 'row', alignItems: 'center', padding: 12, gap: 12 },
  symbol: { width: 32, height: 32, borderRadius: 9, alignItems: 'center', justifyContent: 'center' },
  copy: { flex: 1, minWidth: 0, gap: 4 },
  dismiss: { width: 44, minHeight: 44, alignItems: 'center', justifyContent: 'center' },
});
